import React, { useEffect } from 'react';
import Translate from '../../../../utils/Translate';
import GhostButton from '../../GhostButton/GhostButton';

import './MergeAccountSuccess.css';
import { EmailStore } from '../../../../state/EmailStore';
import { PersonalInfoStore } from '../../../../state/PersonalInfoStore';
import HtmlMessage from '../../HtmlMessage/HtmlMessage';
import TopicTracker from '../../../../tracking/TopicTracker';
import Navigator from '../../../../utils/Navigator';

export const MergeAccountSuccess = () => {
  const onFinishMergeAccount = () => {
    TopicTracker.click('email', 'success-back-profile');
    window.location.href = Navigator.emailsPage;
  };

  useEffect(() => {
    TopicTracker.show('email', 'success', { merge_status: EmailStore.getLoyaltyMergeStatus() });
  }, []);

  const thanksMessageKey = `merge-account-success.${EmailStore.getMergeActionType()}.text`;

  return (
    <div className="thanks-container">
      <div className="thanks-title-container">
        <i className="check-icon eva-3-icon-checkmark-circle -eva-3-tc-brand-tertiary-4" />
        <h3 className="thanks-title eva-3-h3">{Translate.message(`merge-account-success.${EmailStore.getMergeActionType()}.title`)}</h3>
      </div>
      <div className="thanks-message">
        {
          EmailStore.isMergeActionType() ?
            <p>{Translate.message(thanksMessageKey)}</p>
            :
            <HtmlMessage
              message={Translate.message(thanksMessageKey, {
                currentEmail: PersonalInfoStore.getPrimaryEmail(),
                joinEmail: EmailStore.getMergeableEmail(),
              })}
            />
        }
      </div>
      <div>
        <GhostButton
          className="-darken"
          onClick={onFinishMergeAccount}
          text={Translate.message('merge-account-success.button')}
        />
      </div>
    </div>
  );
};

